import { SITE_CONFIG } from '../config/site';

// Content ships from the reviewed bundle only (Git is the single source of
// truth). English is part of the entry bundle (main.jsx seeds hydration with
// it); zh/es/ja are separate chunks fetched on switch. Note that a failed
// import() stays failed in the browser's module map - recovery is a reload
// (see TranslationProvider.retryLocale). The whitepaper is a static asset per
// locale: English is the authoritative version; zh/es/ja are reference
// translations of it.
const PDF_BY_LOCALE = {
  en: './pdfs/GETTR-Token-en.pdf',
  zh: './pdfs/GETTR-Token-zh.pdf',
  es: './pdfs/GETTR-Token-es.pdf',
  ja: './pdfs/GETTR-Token-ja.pdf',
};

const pdfPathForLocale = (locale) => PDF_BY_LOCALE[locale] || PDF_BY_LOCALE.en;

const LOCALE_LOADERS = {
  en: () => import('../translations/en.json'),
  zh: () => import('../translations/zh.json'),
  es: () => import('../translations/es.json'),
  ja: () => import('../translations/ja.json'),
};

export const loadLocaleTranslations = async (locale) => {
  const load = LOCALE_LOADERS[locale] ?? LOCALE_LOADERS[SITE_CONFIG.defaultLocale];
  const mod = await load();
  return mod.default;
};

export const getPdfUrl = async (locale) => pdfPathForLocale(locale);

export async function fetchWhitepaperPdfBlob(locale) {
  const response = await fetch(pdfPathForLocale(locale));
  if (!response.ok) {
    throw new Error('Failed to load PDF file');
  }
  return response.blob();
}
